import { environment } from 'src/environments/environment';

interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  { name: 'processout', src: 'https://js.processout.com/processout.js' },
  { name: 'google-pay', src: 'https://pay.google.com/gp/p/js/pay.js' },
  { name: 'google-maps', src: `https://maps.googleapis.com/maps/api/js?key=${environment.gMaps.key}&libraries=places` },
  { name: 'doofinder', src: `https://eu1-config.doofinder.com/2.x/${environment.doofinderStoreId}.js` },
];
